import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBoxCircleCheck,
  faFlaskGear,
  faUserDoctorHairLong,
  faMemoCircleCheck,
} from "@fortawesome/pro-regular-svg-icons";
import { TrackerStepId } from "./trackerSteps";

export const TRACKER_STEP_ICONS: Record<TrackerStepId, IconDefinition> = {
  [TrackerStepId.KitReceived]: faBoxCircleCheck,
  [TrackerStepId.LabProcessing]: faFlaskGear,
  [TrackerStepId.ProviderReviewing]: faUserDoctorHairLong,
  [TrackerStepId.ResultsReady]: faMemoCircleCheck,
};
